import React, { useState } from "react"
import { Link, useHistory, useParams } from "react-router-dom"
import { useCart } from "react-use-cart"
import Cart from "../../pages/cart/Cart"
import { checkLogin } from "../../utils/ApiUtils"
import ModalContainer from "../ModalContainer/ModalContainer"
import "./navstyles.scss"
import { HiMenu } from "react-icons/hi"
import { RiCloseFill } from "react-icons/ri"
import { authLink, midLinks, loggedInUserLink } from "./constants"

// import Logo from "../../assets/gift-logo-sd.svg";

const Navbar = () => {
  const [showCart, setShowCart] = useState(false)
  const [open, setOpen] = useState(false)
  const history = useHistory()

  const { items } = useCart()

  const { slug } = useParams()

  return (
    <>
      <div
        className={`w-full  top-0 left-0 right-0 bottom-0 h-24 z-20 bg-sbg-white ${
          open && "-mb-nav-open"
        }`}
      >
        <nav className="items-center py-10 justify-between global-container flex  medium:hidden mobiles:justify-between mobiles:flex">
          {showCart && (
            <ModalContainer>
              <Cart closeCart={() => setShowCart(false)} />
            </ModalContainer>
          )}
          <h2
            to="/"
            className="flex items-center"
            onClick={() => history.push("/")}
          >
            <img
              src={require("../../assets/gift-logo-sd.svg").default}
              alt="logo"
              className="h-10 -mt-2"
            />
            <p className="ml-2 font-bold text-2xl">Sabigift</p>
          </h2>

          <div className="medium:hidden flex justify-between w-2/6 min-w-min">
            {midLinks.map(({ name, link }) => {
              return (
                <Link to={link} key={link}>
                  {name}
                </Link>
              )
            })}
          </div>
          {/* <div className="flex justify-between w-2/6 min-w-min">
          <Link to="/">How it Works</Link>
          <Link to="/create-event">Registry</Link>
          <Link to="/find-registry">Find an event</Link>
        </div> */}

          {!checkLogin() ? (
            <div className="flex medium:hidden">
              {authLink.map(({ name, link }) => {
                return (
                  <Link
                    key={link}
                    to={link}
                    className={`py-2.5 px-11 rounded-lg text-base ${
                      name === "Log In"
                        ? "border border-sbg-light-green text-lgreen"
                        : "bg-sbg-light-green text-transparent ml-3  text-white"
                    }`}
                  >
                    {name}
                  </Link>
                )
              })}
            </div>
          ) : (
            <div className="flex medium:hidden">
              {loggedInUserLink.map(({ name, link }) => {
                return (
                  <Link
                    to={link}
                    key={link}
                    className={`py-2.5 px-11 rounded-lg text-base ${
                      name === "Dashboard"
                        ? "border border-sbg-light-green text-lgreen"
                        : "bg-sbg-light-green text-transparent ml-3  text-white"
                    }`}
                  >
                    {name}
                  </Link>
                )
              })}
            </div>
          )}
          <div className={`${slug ? "navbar__cart mobiles:hidden" : "hidden"}`}>
            <img
              src={require("../../assets/cart.svg").default}
              alt="cart"
              className="h-6 cursor-pointer m-auto"
              onClick={() => setShowCart(true)}
            />
            <div className="cart__item-count">{items.length}</div>
          </div>

          <div className="mobiles:flex  hidden">
            <div className={`${slug ? "navbar__cart mr-7" : "hidden"}`}>
              <img
                src={require("../../assets/cart.svg").default}
                alt="cart"
                className="h-6 cursor-pointer m-auto"
                onClick={() => setShowCart(true)}
              />
              <div className="cart__item-count">{items.length}</div>
            </div>
            {!open ? (
              <HiMenu
                style={{ fontSize: 26 }}
                onClick={() => {
                  setOpen(true)
                }}
              />
            ) : (
              <RiCloseFill
                style={{ fontSize: 26 }}
                onClick={() => {
                  setOpen(false)
                }}
              />
            )}
          </div>
        </nav>
        <div className={` mobile-nav-li my-4 ${open ? "block" : "hidden"}`}>
          {midLinks.map(({ name, link }) => {
            return (
              <li className="py-3 px-6">
                <Link
                  onClick={() => {
                    setOpen(false)
                  }}
                  to={link}
                  key={link}
                >
                  {name}
                </Link>
              </li>
            )
          })}
          {!checkLogin()
            ? authLink.map(({ name, link }) => {
                return (
                  <li className="py-3 px-6">
                    <Link
                      to={link}
                      key={link}
                      className={`py-2.5 px-11 rounded-lg text-base ${
                        name === "Log In"
                          ? "border border-sbg-light-green text-lgreen"
                          : "bg-sbg-light-green text-transparent  text-white"
                      }`}
                    >
                      {name}
                    </Link>
                  </li>
                )
              })
            : loggedInUserLink.map(({ name, link }) => {
                return (
                  <li className="py-3 px-6">
                    <Link
                      to={link}
                      key={link}
                      className={`py-2.5 px-11 rounded-lg text-base ${
                        name === "Dashboard"
                          ? "border border-sbg-light-green text-lgreen"
                          : "bg-sbg-light-green text-transparent  text-white"
                      }`}
                    >
                      {name}
                    </Link>
                  </li>
                )
              })}
        </div>
      </div>
    </>
  )
}

export default Navbar
